require('parsleyjs');
jQuery(document).ready(function($){
    // $('input, textarea, select').parsley();
    $('#user_login, #user_pass').parsley({
        required: true,
        trigger: 'keyup'
    });
    $('#tribe-bar-date').parsley({
        trigger: 'keyup change input mouseout blur',
        pattern: /.+/
    })
    $('#tribe-bar-search').parsley({
        trigger: 'keyup',
        pattern: /.*/
    });
});